(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/game-info.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/game-info.js');

'use strict';

const _React = React,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const formatCurrency = svs.utils.format.Currency;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const GameInfo = () => {
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors;
  const sharePrice = useSelector(selectors.selectSharePrice);
  const sharesLeft = useSelector(selectors.selectSharesLeft);
  const totalShares = useSelector(selectors.selectTotalShares);
  const isOpen = useSelector(selectors.selectIsOpen);
  const _useSelector = useSelector(selectors.selectGame),
    rowCount = _useSelector.rowCount;
  const hasFewSharesLeft = isOpen && sharesLeft <= 3;
  return React.createElement("div", null, React.createElement("div", {
    className: "ng-fg-card-body-row"
  }, React.createElement("div", {
    className: "ng-fg-card-body-item price-per-share"
  }, React.createElement("span", null, "Pris per andel"), React.createElement("br", null), React.createElement("div", {
    className: "ng-fg-card-body-item-large-text"
  }, "".concat(formatCurrency(sharePrice), " kr")))), React.createElement("hr", {
    className: "ng-fg-hr margin-0"
  }), React.createElement("div", {
    className: "ng-fg-card-body-row"
  }, React.createElement("div", {
    className: "ng-fg-card-body-item"
  }, React.createElement("span", null, "Antal rader"), React.createElement("div", {
    className: "ng-fg-card-body-item-large-text"
  }, rowCount)), React.createElement("hr", {
    className: "ng-fg-hr-vertical"
  }), React.createElement("div", {
    className: "ng-fg-card-body-item"
  }, React.createElement("span", null, "Andelar kvar"), React.createElement("br", null), React.createElement("div", {
    className: "ng-fg-card-body-item-large-text".concat(hasFewSharesLeft ? ' ng-fg-few-shares-attention' : '')
  }, sharesLeft, "/", totalShares))), React.createElement("hr", {
    className: "ng-fg-hr margin-0"
  }));
};
svs.numbergames.fractiongames.components.gamecard.GameInfo = GameInfo;

 })(window);